// extracted by mini-css-extract-plugin
export default {"list":"AHKj12RanA3GzGsTkdYT"};